import React, { useState, useEffect } from "react";
import { string, bool, object } from "prop-types";

import DfpAd from "../../dfp-ad";

import "./topAd.m.css";
import { connect } from "react-redux";
import get from "lodash/get";
import { refreshDfpAds } from "@quintype/components";

const TopAd = ({ className = "", publisherAttributes, pageType, isTopAd, currentPath }) => {
  const [showTopAd, setShowTopAd] = useState(true);

  const getAdTypes = () => {
    if (publisherAttributes.lang === "en") {
      switch (pageType) {
        case "home-page":
          return "EnPalo_HP_970x90_T1";
        default:
          return "EnPalo_ROS_728x90_T1";
      }
    } else {
      switch (pageType) {
        case "home-page":
          return "Home_728x90_T1";
        default:
          return "News_728x90_T1";
      }
    }
  };

  useEffect(() => {
    setShowTopAd(true);

    if (
      window &&
      (window.location.href.includes("auth.prothomalo") || window.location.href.includes("auth-uat.prothomalo"))
    ) {
      setShowTopAd(false);
    }
  });

  useEffect(() => {
    pageType !== "home-page" && showTopAd && refreshDfpAds("header-ad");
  }, [window.location.href]);

  useEffect(() => {
    setShowTopAd(false);
    if (
      window &&
      (window.location.href.includes("auth.prothomalo") || window.location.href.includes("auth-uat.prothomalo"))
    ) {
      setShowTopAd(false);
    }
  }, [pageType]);

  return isTopAd && pageType !== "story-page" ? (
    <div styleName="ad-slot" className={className}>
      {showTopAd && <DfpAd adtype={getAdTypes()} topAd={true} slotId="header-ad" />}
    </div>
  ) : null;
};

TopAd.propTypes = {
  adtype: string,
  className: string,
  publisherAttributes: object,
  pageType: string,
  isTopAd: bool,
  currentPath: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  pageType: get(state, ["qt", "pageType"]),
  isTopAd: get(state, ["topAdReducer", "isTopAd"], true),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null),
});

export default connect(mapStateToProps, null)(TopAd);
